export default __webpack_public_path__ + "static/media/EAST2450.34I-34241_-18458_0.f83c6161.jpg";